export var menuItemTheme = {
  baseStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 's',
    alignItems: 'center',
    height: {
      xs: '56px',
      s: '44px'
    },
    paddingX: {
      xs: 'm',
      s: 's'
    },
    paddingY: {
      xs: 's',
      s: 'none'
    },
    color: 'neutral.black',
    cursor: 'pointer',
    transition: 'background-color 0.1s ease-in-out',
    textStyle: 'body3Semi',
    _hover: {
      backgroundColor: 'neutral.lightest'
    },
    _selected: {
      backgroundColor: 'neutral.lightest'
    },
    _disabled: {
      color: 'neutral.light',
      backgroundColor: 'unset',
      cursor: 'not-allowed'
    },
    _focusVisible: {
      outlineColor: 'focus.focus',
      outlineOffset: '-2px'
    }
  },
  variants: {
    default: {
      color: 'neutral.black'
    },
    critical: {
      color: 'critical.main'
    }
  },
  defaultProps: {
    variant: 'default'
  }
};
//# sourceMappingURL=MenuItem.theme.js.map